export default __webpack_public_path__ + "static/media/arrow_right_white.437f7d90.svg";